import { createServerFn } from "@tanstack/react-start";
import type { LiveSeoPage } from "./liveSeo";

export type LiveSeoContent = Pick<
	LiveSeoPage,
	"path" | "title" | "h1" | "h2s" | "paragraphs" | "image"
>;

// The legacy snapshot contains every page's metadata and schema. Keep it on the
// server, and serialize only the selected page's renderable content.
export const getLiveSeoContent = createServerFn({ method: "GET" })
	.inputValidator((path: string) => {
		if (typeof path !== "string") throw new Error("Expected a page path");
		return path;
	})
	.handler(async ({ data }): Promise<LiveSeoContent | null> => {
		const { getLiveSeoPage } = await import("./liveSeo");
		const page: LiveSeoPage | undefined = getLiveSeoPage(data);
		if (!page) return null;
		const { path, title, h1, h2s, paragraphs, image } = page;
		return {
			path,
			title,
			h1,
			h2s: [...h2s],
			paragraphs: [...paragraphs],
			image,
		};
	});
